import { API, api } from "@/lib/api";

export const reportDownloadUrl = (reportId) => `${API}/reports/${reportId}/download`;

export const getJourneyUi = async () => (await api.get("/journey/ui")).data;
export const getQuestions = async () => (await api.get("/questions")).data;
export const getPricing = async () => (await api.get("/journey/pricing")).data;
export const getMe = async () => (await api.get("/auth/me")).data;
export const exchangeGoogleSession = async (sessionId, consent) =>
  (await api.post("/auth/session", { session_id: sessionId, consent })).data;
export const saveProfile = async (payload) => (await api.put("/me/profile", payload)).data;
export const logout = async () => (await api.post("/auth/logout")).data;
export const startAssessment = async (stage, isNew = false, requestId = null) =>
  (await api.post("/assessments", { stage, new: isNew, request_id: requestId })).data;
export const saveAssessmentAnswer = async (assessmentId, questionId, answer) =>
  (await api.patch(`/assessments/${assessmentId}/answers/${questionId}`, { answer })).data;
export const completeFreeAssessment = async (assessmentId) =>
  (await api.post(`/assessments/${assessmentId}/complete-free`)).data;
export const completePaidAssessment = async (assessmentId) =>
  (await api.post(`/assessments/${assessmentId}/complete-paid`)).data;
export const getAssessments = async () => (await api.get("/assessments")).data;
export const getAccount = async () => (await api.get("/account")).data;
export const requestInvoice = async (assessmentId) =>
  (await api.post("/orders", { assessment_id: assessmentId })).data;
export const getAdminOrders = async () => (await api.get("/admin/orders")).data;
export const approveAdminOrder = async (ref) =>
  (await api.post(`/admin/orders/${encodeURIComponent(ref)}/approve`)).data;
export const deleteMyData = async (confirmation) =>
  (await api.post("/me/delete", { confirmation })).data;